export default {"src":"/_next/static/media/UWMC.a4bdfb69.svg","height":18,"width":18};